import {has} from 'lodash';

const ALPHABET_LENGTH = 26;
const CHAR_CODE_A = 65;

export function scrollAdPosition(adPosition) {
  return !has(['top', 'bottom'], adPosition);
}

// Use this for See All Slides and Section Ads
export function* standardAdPositionGenerator() {
  let index = 0;
  for (;;) {
    yield getAlphabeticAdPosition(++index);
  }
}

// Use this for ads in modules on a channel page
export function* channelAdPositionGenerator() {
  yield 'top';
  let index = 0;
  for (;;) {
    yield getAlphabeticAdPosition(++index);
  }
}

// Use this for ads in modules on an article page
export function* relatedContentAdPositionGenerator() {
  yield 'related';
  let index = 0;
  for (;;) {
    yield `related-${getAlphabeticAdPosition(++index)}`;
  }
}

/*
 * Converts numbers to capital letters (based on 1-index number)
 * where 1 => A, 2 => B, 27 => AA, 28 => AB and so on
 */
function getAlphabeticAdPosition(num) {
  if (num < 1) {
    throw new Error("getAlphabeticAdPosition is 1-indexed! Don't pass in 0.");
  }
  const index = num - 1;
  const letter = String.fromCharCode(CHAR_CODE_A + index % ALPHABET_LENGTH);
  const quotient = Math.floor(index / ALPHABET_LENGTH);
  return quotient > 0
    ? getAlphabeticAdPosition(quotient) + letter
    : letter;
}
